import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import useErrorHandler from '../../hooks/useErrorHandler'
import Protected from '../Protected'
import { PATHS } from '../Routes'
import './Disable.css'
import * as Yup from 'yup'
import { Form, Formik, FormikHelpers } from 'formik'
import FormErrorDisplay from '../common/FormErrorMessages'
import { Button } from 'semantic-ui-react'
import { UserDisable } from '../../models/Disable'
import ProfileService from '../../services/ProfileService'
import { ICallout } from '../../models/Callout'
import LoaderContext from '../context/FormLoader'
import useCallout from '../../hooks/useCallout'
import Conditional from '../common/Conditional'
import CalloutDisplay from '../common/CalloutDisplay'
import FWOTextAreaInput from '../form/FWOTextAreaInput'
const DisableUser = observer(() => {
  const [userErrors, , handleErrors, , clearErrors] = useErrorHandler()
  const [isLoading, setIsLoading] = useState(true)

  const mountedRef = useRef(false)
  const [callout, setCallout] = useState<ICallout[]>([])
  const [getCallout] = useCallout('DisableMyAccount', 'Before')
  const queryParams = new URLSearchParams(location.search)
  const loader = useContext(LoaderContext)

  const { disableUser } = ProfileService

  const history = useHistory()

  const validateSchema = Yup.object({
    reasonToDisable: Yup.string()
      .required('A reason is required')
      .max(2048, 'Reason for disable must be wintin 2048 characters'),
  })
  const initialValues = {
    emailAddress: decodeURIComponent(queryParams.get('emailAddress')),
    reasonToDisable: '',
  }

  function handleFormSubmit(
    values: UserDisable,
    actions: FormikHelpers<UserDisable>
  ) {
    clearErrors()
    disableUser(values)
      .then(() => {
        if (mountedRef.current) {
          history.push(PATHS.Profile + '?disable=true')
        }
      })
      .catch((error) => {
        handleErrors(error)
      })
      .finally(() => {
        if (mountedRef.current) {
          window.scrollTo(0, 0)
          actions.setSubmitting(false)
        }
      })
  }

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setCallout(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      window.scrollTo(0, 0)
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return (
    <Protected>
      <nav className="breadcrumbs dnd-s-mob">
        <ol>
          <li>
            <Link className="underline" to={PATHS.Profile}>
              Back to previous page
            </Link>
          </li>
        </ol>
      </nav>
      <div className="content-wrapper">
        <article className="main">
          <p></p>
          <p></p>
          <h1>Disable My account</h1>
          <Conditional if={!isLoading}>
            {callout &&
              callout.map((c, i) => (
                <CalloutDisplay
                  key={i}
                  className=""
                  content={c.content}
                  name="DisableMyAccount"
                />
              ))}
          </Conditional>
          <FormErrorDisplay
            show={userErrors?.length > 0}
            errorsList={userErrors}
            heading="Please review the following errors"
          />

          <p></p>
          <Formik
            validationSchema={validateSchema}
            enableReinitialize
            initialValues={initialValues}
            onSubmit={(values, actions) => handleFormSubmit(values, actions)}
          >
            {({ isValid, isSubmitting, dirty }) => (
              <Form className="ui form osp-variant large" autoComplete="off">
                <FWOTextAreaInput
                  placeholder="Enter reason here"
                  label="Reason for disabling My account"
                  name="reasonToDisable"
                  aria-label="Reason for disable"
                  required={true}
                  rows={5}
                />

                <div className="button-group is-right">
                  <Button
                    disabled={isSubmitting || !dirty || !isValid}
                    loading={isSubmitting}
                    type="submit"
                    content="Submit"
                    className="is-primary"
                  />
                  <Button
                    as={Link}
                    to={PATHS.Profile}
                    type="button"
                    content="Cancel"
                    className="is-secondary"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </article>
      </div>
    </Protected>
  )
})
export default DisableUser
